import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PartyVotingStatusSummaryComponent
} from "@shared/components/party-voting-status-summary/party-voting-status-summary.component";
import { TranslateModule } from "@ngx-translate/core";
import { TableModule } from '@valg-shared/components/table/table.module';
import { CardInformationContentModule } from "@shared/components/cards/card-information-content/card-information-content.module";
import { ResultSummaryModule } from '../result-summary/result-summary.module';



@NgModule({
  declarations: [
    PartyVotingStatusSummaryComponent,
  ],
  exports: [
    PartyVotingStatusSummaryComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    CardInformationContentModule,
    ResultSummaryModule
  ]
})
export class PartyVotingStatusSummaryModule { }
